'use client';
import type { Assign } from '@ark-ui/react';
import { Collapsible } from '@ark-ui/react';
import {
  type CollapsibleVariantProps,
  collapsible,
} from '@terra/ui-styled-system';
import type { ComponentProps, HTMLStyledProps } from '@terra/ui-styled-system';
import { createStyleContext } from './utils/create-style-context';

const { withProvider, withContext } = createStyleContext(collapsible);

export type RootProviderProps = ComponentProps<typeof RootProvider>;
export const RootProvider = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Collapsible.RootProviderProps>,
    CollapsibleVariantProps
  >
>(Collapsible.RootProvider, 'root');

export type RootProps = ComponentProps<typeof Root>;
export const Root = withProvider<
  HTMLDivElement,
  Assign<
    Assign<HTMLStyledProps<'div'>, Collapsible.RootProps>,
    CollapsibleVariantProps
  >
>(Collapsible.Root, 'root');

export const Content = withContext<
  HTMLDivElement,
  Assign<HTMLStyledProps<'div'>, Collapsible.ContentProps>
>(Collapsible.Content, 'content');

export const Trigger = withContext<
  HTMLButtonElement,
  Assign<HTMLStyledProps<'button'>, Collapsible.TriggerProps>
>(Collapsible.Trigger, 'trigger');

export { CollapsibleContext as Context } from '@ark-ui/react';
